import Swiper from "swiper/bundle";

const swipers = [...document.querySelectorAll("#dinamic .list .swiper")].map(
  (el) => {
    const swiper = new Swiper(
      `#dinamic .list .swiper[data-index="${el.dataset.index}"]`,
      {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        navigation: {
          nextEl: `#dinamic .list .swiper[data-index="${el.dataset.index}"] .next`,
          prevEl: `#dinamic .list .swiper[data-index="${el.dataset.index}"] .prev`,
        },
        autoplay: {
          delay: 5000,
        },
        on: {
          init: function () {
            this.autoplay?.stop();
          },
        },
      }
    );
    return swiper;
  }
);
document.addEventListener("accordeon_changed", ({ detail: e }) => {
  if (swipers.length === 0) return;

  const index = parseInt(e.accordeon.dataset.name.split("-")[1]);
  if (e.open) {
    swipers[index].update();
    swipers[index].autoplay?.start();
  } else {
    swipers[index].update();
    [swipers[index].autoplay?.stop()];
    swipers[index].slideTo(0);
  }
});
